/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
// tslint:disable:no-reference
/* eslint-disable no-duplicate-imports */
/* tslint:disable:max-line-length */
/* tslint:disable:max-func-body-length */
/* tslint:disable:cyclomatic-complexity */
/* tslint:disable:jsx-no-lambda */
/* tslint:disable:jsx-no-multiline */
/* tslint:disable:jsx-wrap-multiline */
/// <reference path="types/MicrosoftMaps/Microsoft.Maps.All.d.ts" />

import { IStoreInfo } from '@msdyn365-commerce-modules/bopis-utilities';
import {
    ArrayExtensions,
    getOrgUnitLocationsByArea,
    GetOrgUnitLocationsByAreaInput,
    IFullOrgUnitAvailability
} from '@msdyn365-commerce-modules/retail-actions';

import getFullAvailableInventoryNearby, {
    GetFullAvailableInventoryNearbyInput
} from '../../themes/dobbies/actions/get-full-available-inventory-nearby.override.action';
import {
    getTelemetryObject,
    IModuleProps,
    INodeProps,
    ITelemetryContent,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    NodeTag
} from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { DeliveryOption, ItemAvailability, OrgUnitLocation, SimpleProduct, StoreHours } from '@msdyn365-commerce/retail-proxy';
import classname from 'classnames';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

import {
    StoreSelectorEmptyMessage,
    StoreSelectorFoundLocationsMessage,
    StoreSelectorLocationLines,
    StoreSelectorSearchForm,
    StoreSelectorTermsOfService,
    StoreSelectorWaiting
} from './components';
import { IDobbiesBuyboxStoreSelectorData } from './dobbies-buybox-store-selector.data';
import {
    buildStoreHours,
    IHoursDisplayInfo,
    secondsToTime
} from './components/dobbies-buybox-store-selector-location-line-item/date-time-helpers';
import {
    IDobbiesBuyboxStoreSelectorProps,
    IDobbiesBuyboxStoreSelectorResources,
    mode as modeEnum,
    searchRadiusUnit as SearchRadiusUnit,
    style as styleEnum
} from './dobbies-buybox-store-selector.props.autogenerated';
import { searchOrgUnitLocationsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/OrgUnitsDataActions.g';
import {
    GetAllAvailableInventoryNearbyInput,
    getAllAvailableInventoryNearbyAction
} from '../../actions/get-all-available-inventory-nearby';
import { ISuggestion } from './interfaces';

import { PdpClickCollectModalStateInput } from '../../actions/pdp-click-collect-modal-state.action';
export interface IStoreSelectorState {
    isSearchInProgress: boolean;
    searchTerm?: string;
    isSeeAllStoreValue: boolean;
    isLocationDisabled?: boolean;
    filteredPickupMode?: string;
    isDisplayProduct: boolean;
    sortByLocation?: boolean;
    isCnC?: boolean;
    CnCPickupIds: (number | undefined)[];
    totalStoreCount: number | undefined;
    latitudeVal: number;
    longitudeVal: number;
    radiusVal: number;
    searchString: string;
    allStore: IFullOrgUnitAvailability[];
    isSearchCompleted: boolean;
    locationData: any;
}

export interface IStoreSelectorViewProps extends IDobbiesBuyboxStoreSelectorProps<IDobbiesBuyboxStoreSelectorData> {
    state: IStoreSelectorState;

    // Containers:
    ModuleProps: IModuleProps;
    BodyContainerProps: INodeProps;
    FooterContainerProps: INodeProps;
    HeaderContainerProps: INodeProps;
    HeaderProps?: React.ReactNode;

    // Components
    locationsMessage?: React.ReactNode;
    search?: React.ReactNode;
    spinner?: React.ReactNode;
    locationsList?: React.ReactNode;
    noLocationsMessage?: React.ReactNode;
    terms?: React.ReactNode;
    headerText?: React.ReactNode;
    sortLocations?: IFullOrgUnitAvailability[];
    locationListProps?: IStoreSelectorLocationLineItemProps[];
    isDisplayProduct: boolean;
    callbacks: {
        closeDialog(): Promise<void>;
        searchTermChanged(searchTerm: string): Promise<void>;
        performSearch(searchTerm: string): Promise<void>;
        selectedLocation(location: OrgUnitLocation | undefined): Promise<void>;
        getAndUpdateUserLocation(): Promise<void>;
        onSuggestionSelected(result: Microsoft.Maps.ISuggestionResult): Promise<void>;
        setPreferredStore(storeId: string | undefined): Promise<void>;
        removePreferredStore(): Promise<void>;
        setSelectedStore(storeId: string | undefined): Promise<void>;
        setOrgUnitStoreInformation(location: OrgUnitLocation | undefined): Promise<void>;
    };
}
/**
 * StoreSelectorLocation Line Resources Interface.
 */

export interface IStoreSelectorLocationLineItemResources {
    contactInfoHeader: string;
    storeHoursHeader: string;
    availabilityInfoHeader: string;
    closedText: string;
    outOfStock: string;
    inStock: string;
    currentLocation: string;
    selectLocation: string;
    selectLocationAriaLabelFormat: string;
    setAsPreferredStoreText: string;
    setAsPreferredStoreTextAriaLabel: string;
    preferredStoreText: string;
    preferredStoreAriaLabel: string;
    quantityText: string;
    days: {
        monday: string;
        tuesday: string;
        wednesday: string;
        thursday: string;
        friday: string;
        saturday: string;
        sunday: string;
        mondayFull: string;
        tuesdayFull: string;
        wednesdayFull: string;
        thursdayFull: string;
        fridayFull: string;
        saturdayFull: string;
        sundayFull: string;
    };
}
/**
 * ILocationHours Interface.
 */

export interface ILocationHours {
    openFrom?: string;
    openTo?: string;
}
/**
 * StoreSelectorLocation Line Item Props Interface.
 */

export interface IStoreSelectorLocationLineItemProps {
    location: OrgUnitLocation;
    storeHours?: StoreHours;
    storeHoursList?: IHoursDisplayInfo[];
    hideStockStatus?: boolean;
    isInStock?: boolean;
    isCurrentLocation?: boolean;
    resources: IStoreSelectorLocationLineItemResources;
    stockStatusLabel?: string;
    storeLocatorView?: boolean;
    isPreferredStoreEnabled?: boolean;
    index: string;
    preferredStoreLocationId: string | null;
    storePickUpOptionList?: DeliveryOption[];
    productPickUpOptionList?: DeliveryOption[];
    selectedStoreLocationId?: string;
    locationOpen?: ILocationHours;
    /**
     * The telemetry content
     */

    telemetryContent?: ITelemetryContent;
    preferredDistanceUnit: string;
    isLocationDisabled?: boolean;
    handlers: {
        onSelected(location: OrgUnitLocation, deliveryMode?: string): void;
        onSetAsPreferredStore(locationId: string | undefined): void;
        onRemovePreferredStore(): void;
    };
    onClick: (locationId: string | undefined) => void;
}

/**
 *
 * Pick Up In Store module.
 * @extends React.Component<IPickUpInStoreProps<IPickUpInStoreData>>}
 */
@observer
class StoreSelector extends React.Component<IDobbiesBuyboxStoreSelectorProps<IDobbiesBuyboxStoreSelectorData>, IStoreSelectorState> {
    private readonly telemetryContent: ITelemetryContent;

    private storeCounter: number;

    constructor(props: IDobbiesBuyboxStoreSelectorProps<IDobbiesBuyboxStoreSelectorData>) {
        super(props);
        this.state = {
            isSearchInProgress: true,
            searchTerm: '',
            isSeeAllStoreValue: false,
            filteredPickupMode: undefined,
            isDisplayProduct: false,
            CnCPickupIds: [],
            totalStoreCount: 0,
            latitudeVal: 0,
            longitudeVal: 0,
            radiusVal: 1,
            searchString: '',
            allStore: [],
            sortByLocation: true,
            isSearchCompleted: false,
            locationData: null
        };
        this.telemetryContent = getTelemetryObject(
            this.props.context.request.telemetryPageName!,
            this.props.friendlyName,
            this.props.telemetry
        );
        this.storeCounter = 0;
    }

    public sortLocations = () => {
        this.setState({
            sortByLocation: !this.state.sortByLocation
        });
    };

    public componentDidMount(): void {
        const {
            context: {
                actionContext: {
                    requestContext: { channel }
                }
            },
            config: { style }
        } = this.props;

        this.props.data.deliveryOptions.then(options => {
            const isCnC = options?.DeliveryOptions?.some(opt => opt.Code === 'ClickCol');
            this.setState({ isCnC });
        });

        // Try using cached location first
        const cachedLocationString = localStorage.getItem('userLocation');
        let cachedLocation: { lat: number; lng: number; timestamp?: number } | null = null;
        const cacheHours = this.props.context.app.config.userLocationCacheTime || 12;
        const CACHE_HOURS_MS = cacheHours * 60 * 60 * 1000;

        try {
            cachedLocation = cachedLocationString ? JSON.parse(cachedLocationString) : null;
        } catch {
            localStorage.removeItem('userLocation');
        }

        // Check if cached location exists and is not older than 12 hours
        const isCacheValid = cachedLocation && cachedLocation.timestamp && Date.now() - cachedLocation.timestamp < CACHE_HOURS_MS;

        // If cached location exists and is valid, use it
        if (cachedLocation && isCacheValid) {
            this.setState({ locationData: { latitude: cachedLocation.lat, longitude: cachedLocation.lng } });
        } else if (navigator.geolocation) {
            // Otherwise get new location from geolocation API
            navigator.geolocation.getCurrentPosition(position => {
                // Cache the location with timestamp
                localStorage.setItem(
                    'userLocation',
                    JSON.stringify({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        timestamp: Date.now()
                    })
                );
                this.setState({ locationData: position.coords });
            });
        }

        // Adding Timeout to make sure it loads the data based upon the preferred store.
        setTimeout(() => {
            this._getAndUpdateStoreLocation();
        }, 0);

        reaction(
            () => this.props.data.storeSelectorStateManager.result && this.props.data.storeSelectorStateManager.result.isDialogOpen,
            async () => {
                const context = this.props.data.storeSelectorStateManager.result?.context;
                if (context?.id === this.props.id) {
                    this._getAndUpdateStoreLocation();
                }
            }
        );

        reaction(
            () =>
                this.props.data.storeSelectorStateManager.result &&
                this.props.data.storeSelectorStateManager.result.context &&
                this.props.data.storeSelectorStateManager.result.context.id,
            async () => {
                const context = this.props.data.storeSelectorStateManager.result?.context;
                if (!context || context?.id === this.props.id) {
                    await this._searchTermChanged('');
                    this._getAndUpdateStoreLocation();
                }
            }
        );

        if (this.props.data.storeSelectorStateManager.result?.loadMapApi) {
            this.props.data.storeSelectorStateManager.result
                ?.loadMapApi({
                    key: channel?.BingMapsEnabled ? channel?.BingMapsApiKey : '',
                    lang: this.props.context?.actionContext?.requestContext.locale,
                    market: this.props.context?.actionContext?.requestContext?.channel?.ChannelCountryRegionISOCode
                })
                .then()
                .catch();
        }

        reaction(
            () => this.props.data.storeSelectorStateManager.result?.loadMapApi,
            () => {
                this.props.data.storeSelectorStateManager.result?.loadMapApi({
                    key: channel?.BingMapsEnabled ? channel.BingMapsApiKey : '',
                    lang: this.props.context?.actionContext?.requestContext.locale,
                    market: this.props.context?.actionContext?.requestContext?.channel?.ChannelCountryRegionISOCode
                });
            }
        );

        reaction(
            () => this.props.data.storeSelectorStateManager.result?.isDialogOpen,
            () => {
                if (!this.props.data.storeSelectorStateManager.result?.isDialogOpen) {
                    const context = this.props.data.storeSelectorStateManager?.result?.context;
                    const styleDefault = style !== undefined ? style : styleEnum.dialog;

                    this.props.data.storeSelectorStateManager.result?.setOrgUnitStoreInformation({
                        id: undefined,
                        showMapViewLink: context && context.showMapViewLink,
                        parentElementRef: context?.parentElementRef,
                        isDialog: styleDefault === styleEnum.dialog,
                        orgUnitStoreInformation: [],
                        onLocationSelected: async orgUnitLocation => {
                            return Promise.resolve();
                        }
                    });
                }
            }
        );

        const urlRoutes = this.props.context.request.url.requestUrl.pathname.split('/');
        const productRecordId = urlRoutes[urlRoutes.length - 1].replace('.p', '');

        const parsedRecordId = Number(productRecordId);
        if (!parsedRecordId) {
            return;
        }
        this.getProductAttributes(parsedRecordId);
    }

    public async getProductAttributes(RecordId: number) {
        const {
            requestContext: {
                apiSettings: { channelId, catalogId }
            }
        } = this.props.context.actionContext;

        const customAttributes = await getAttributeValuesAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            RecordId,
            channelId,
            catalogId
        );
        const inStoreAttribute = customAttributes?.find(attr => attr.Name?.toLowerCase() === 'instoredisplay');

        if (inStoreAttribute?.TextValue?.toLowerCase() === 'yes') {
            this.setState({
                isDisplayProduct: true
            });
        }
    }

    public shouldComponentUpdate(nextProps: IDobbiesBuyboxStoreSelectorProps<IDobbiesBuyboxStoreSelectorData>): boolean {
        const {
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;
        // VSI CUSTOMIZATION Counter Logic to show correct Store Counts
        if (this.state.totalStoreCount !== this.props.data.availabilitiesWithHours.result?.length) {
            const ids = this.props.data.availabilitiesWithHours?.result?.filter(item => {
                return this.state.CnCPickupIds.some(f => {
                    return (
                        f === item.OrgUnitAvailability?.OrgUnitLocation?.ChannelId &&
                        f === item.OrgUnitAvailability?.OrgUnitLocation?.ChannelId
                    );
                });
            });

            if (this.props.config.storeSelectorHeaderText?.includes('Check stock')) {
                this.setState({ totalStoreCount: this.props.data.availabilitiesWithHours.result?.length });
            } else {
                if (this.state.totalStoreCount !== ids?.length) {
                    this.setState({ totalStoreCount: ids?.length });
                }
            }
        }
        // VSI CUSTOMIZATION Counter Logic to show correct Store Counts
        const context = storeSelectorStateManager ? storeSelectorStateManager.context : undefined;
        if (context && context.id === this.props.id) {
            return true;
        }
        return false;
    }

    // eslint-disable-next-line complexity -- disabling the complexity for this method for now as its causing lot of other warnings
    public render(): JSX.Element {
        const {
            config: {
                termsOfServiceLink,
                className,
                heading,
                mode,
                style,
                setAsPreferredStore,
                showAllStores,
                lookupRadius,
                enablePickupFilterToShowStore,
                storeSelectorHeaderText,
                showLiveQuantity,
                searchRadiusUnit,
                autoSuggestionEnabled: isAutoSuggestionsEnabled,
                autoSuggestOptions
            },
            context: {
                telemetry,
                app: { config: appConfig },
                actionContext: {
                    requestContext: { channel, cookies, locale }
                }
            },
            resources,
            data: {
                availabilitiesWithHours: { result: availabilitiesWithHours },
                storeSelectorStateManager: { result: storeSelectorStateManager },
                storeLocations: { result: storeLocations }
            }
        } = this.props;
        this.storeCounter = 0;
        const context = storeSelectorStateManager ? storeSelectorStateManager.context : undefined;
        const isDialogOpen: boolean = storeSelectorStateManager
            ? storeSelectorStateManager.isDialogOpen && context?.id === this.props.id
            : false;
        const styleDefault = style !== undefined ? style : styleEnum.dialog;
        const modeDefault = mode !== undefined ? mode : modeEnum.pickupInStore;
        const inlineView = styleDefault === styleEnum.inline;
        const locatorView = modeDefault === modeEnum.findStores;
        const hideInventory = locatorView;
        const selectedStoreLocationId = storeSelectorStateManager?.selectedStoreLocationId;
        const preferredStore: IStoreInfo | undefined = storeSelectorStateManager?.preferredStore;
        const displayList = storeSelectorStateManager?.listMapViewState?.displayList;
        const isPreferredStoreEnabled = setAsPreferredStore && cookies?.isConsentGiven();
        const showLocationView =
            context &&
            (context.showMapViewLink === undefined || context.showMapViewLink) &&
            locatorView &&
            storeSelectorStateManager?.isMapModuleLoaded;

        const StoreSelectorActions = {
            toggleListMapViewState(): void {
                storeSelectorStateManager?.toggleListMapViewState();
            }
        };

        const configHeading: any = heading ? heading : locatorView ? storeSelectorHeaderText : storeSelectorHeaderText;
        const preferredDistanceUnit =
            searchRadiusUnit === SearchRadiusUnit.kilometers ? resources.kilometersShortText : resources.milesShortText;

        const preferredLocationId = preferredStore?.StoreId ? preferredStore.StoreId : '';
        let storeLocationList: IFullOrgUnitAvailability[] | undefined = hideInventory ? storeLocations : availabilitiesWithHours;
        let isZipMatchedSearch = false;
        if (storeLocationList) {
            storeLocationList = this._sortStores(storeLocationList, isPreferredStoreEnabled, preferredLocationId);
        }

        if (storeLocationList) {
            storeLocationList = [...storeLocationList].sort((a, b) => {
                if (this.state.searchTerm && storeLocationList && this.state.searchTerm.trim() !== '') {
                    const searchZip = this.state.searchTerm
                        .trim()
                        .toUpperCase()
                        .replace(/\s+/g, '');

                    const zipA = (a.OrgUnitAvailability?.OrgUnitLocation?.Zip || '').toUpperCase().replace(/\s+/g, '');
                    const zipB = (b.OrgUnitAvailability?.OrgUnitLocation?.Zip || '').toUpperCase().replace(/\s+/g, '');
                    const isExactA = zipA === searchZip;
                    const isExactB = zipB === searchZip;
                    if (isExactA && !isExactB) {
                        return -1;
                    }
                    if (!isExactA && isExactB) {
                        return 1;
                    }
                    if (
                        (storeLocationList[0]?.OrgUnitAvailability?.OrgUnitLocation?.Zip || '').toUpperCase().replace(/\s+/g, '') ===
                        searchZip
                    ) {
                        isZipMatchedSearch = true;
                    }
                }

                const distA = a.OrgUnitAvailability?.OrgUnitLocation?.Distance ?? Infinity;
                const distB = b.OrgUnitAvailability?.OrgUnitLocation?.Distance ?? Infinity;
                return distA - distB;
            });
        }
        const enableOutofStock = appConfig?.enableStockCheck || false;
        const alreadySelectedLocation = context ? context.alreadySelectedLocation : undefined;
        const productPickUpOptionList = storeSelectorStateManager?.context?.deliveryOptions?.DeliveryOptions;
        if (this.state.filteredPickupMode && storeLocationList) {
            storeLocationList = this.onFilterLocations(storeLocationList, this.state.filteredPickupMode);
        }
        const locationListProps = this._getStoreLocationListProps(
            enableOutofStock,
            locatorView,
            preferredLocationId,
            isPreferredStoreEnabled,
            selectedStoreLocationId,
            storeLocationList ?? null,
            preferredDistanceUnit,
            alreadySelectedLocation,
            productPickUpOptionList
        );

        let storesList = storeLocationList;

        const isUserAuthenticated = this.props.context.request.user.isAuthenticated;
        const customerLocalStore = this.props.data.customerInformation.result?.Attributes?.find(attr => attr.Name === 'Local Store');

        const allStores = this.state.allStore ?? [];
        const alreadySelectedStore = allStores.find(
            store => store.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitNumber === context?.alreadySelectedLocation?.OrgUnitNumber
        );
        const preferStore = allStores.find(
            store => store.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitName === customerLocalStore?.AttributeValue?.StringValue
        );

        function moveToTopUnique(list: any[], storeToMove: any) {
            if (!storeToMove) {
                return list;
            }
            const filtered = list.filter(
                s =>
                    s.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitNumber !==
                    storeToMove.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitNumber
            );
            return [storeToMove, ...filtered];
        }

        const hasSearchTerm = this.state.searchTerm && this.state.searchTerm.trim() !== '' && !isZipMatchedSearch;

        if ((isZipMatchedSearch || hasSearchTerm) && storeLocationList?.length) {
            storesList = storeLocationList.slice(0, 5);
        } else {
            if (!this.state.isSeeAllStoreValue) {
                storesList = storeLocationList?.slice(0, 5);
            } else {
                storesList = storeLocationList?.sort((a, b) => {
                    const nameA = a.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitName ?? '';
                    const nameB = b.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitName ?? '';
                    return nameA.localeCompare(nameB);
                });

                if (alreadySelectedStore) {
                    storesList = moveToTopUnique(storesList as any, alreadySelectedStore);
                }
            }

            if (isUserAuthenticated && storesList?.length) {
                let updatedList = [...storesList];

                if (alreadySelectedStore) {
                    updatedList = moveToTopUnique(updatedList, alreadySelectedStore);
                } else if (preferStore) {
                    updatedList = moveToTopUnique(updatedList, preferStore);
                }

                const seen = new Set<string>();
                updatedList = updatedList.filter(item => {
                    const id = item.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitNumber;
                    if (!id) {
                        return true;
                    }
                    if (seen.has(id)) {
                        return false;
                    }
                    seen.add(id);
                    return true;
                });

                storesList = this.state.isSeeAllStoreValue ? updatedList : updatedList.slice(0, 5);
            }
            // else if (alreadySelectedStore) {
            //     storesList = moveToTopUnique(storesList as any, alreadySelectedStore);
            // }
        }

        storesList = storesList ?? [];

        const viewProps = {
            ...(this.props as IDobbiesBuyboxStoreSelectorProps<IDobbiesBuyboxStoreSelectorData>),
            state: this.state,

            ModuleProps: {
                tag: inlineView ? ('div' as NodeTag) : Modal,
                moduleProps: this.props,
                className: classname(
                    `ms-store-${inlineView ? 'locate ms-store-locate__dialog' : 'select ms-store-select__dialog'} `,
                    className,
                    inlineView ? '' : 'msc-modal-input-required'
                ),
                autoFocus: true,
                fade: true,
                isOpen: isDialogOpen,
                'aria-label': configHeading,
                onClosed: () => {
                    this._closeDialog();
                    document.body.classList.remove('store-locator-open');
                },
                horizontalPosition: 'center',
                verticalPosition: 'center',
                toggle: this._closeDialog,
                onOpened: () => {
                    this.props.context.actionContext.update(new PdpClickCollectModalStateInput(), { isModalOpen: true });
                    document.body.classList.add('store-locator-open');
                }
            },
            HeaderContainerProps: {
                tag: inlineView ? ('div' as NodeTag) : ModalHeader,
                className: `ms-store-select__${inlineView ? 'header' : 'modal-header'}`,
                toggle: this._closeDialog
            },
            HeaderProps: configHeading && (
                <Msdyn365.Text
                    className=''
                    {...configHeading}
                    tag='h2'
                    text={configHeading}
                    editProps={{ onEdit: this.handleHeadingChange, requestContext: this.props.context.request }}
                />
            ),
            FooterContainerProps: {
                tag: inlineView ? ('div' as NodeTag) : ModalFooter,
                className: `ms-store-select__${inlineView ? 'footer' : 'modal-footer'} ${!displayList ? 'map-only-view' : ''}`
            },
            BodyContainerProps: {
                tag: inlineView ? ('div' as NodeTag) : ModalBody,
                className: `ms-store-select__${inlineView ? 'body' : 'modal-body'}`
            },
            locationsMessage: !this.state.isLocationDisabled && (
                <StoreSelectorFoundLocationsMessage
                    resources={resources}
                    locations={this.state.totalStoreCount}
                    searchRadius={lookupRadius || 50}
                    preferredDistanceUnit={preferredDistanceUnit}
                    isSeeAllStore={this.state.isSeeAllStoreValue}
                />
            ),
            search: (
                <StoreSelectorSearchForm
                    value={this.state.searchTerm || ''}
                    resources={resources}
                    performSearch={this._performSearch}
                    searchTermChanged={this._searchTermChanged}
                    showAllStores={showAllStores}
                    id={this.props.id}
                    onShowAllStores={this.onShowAllStoresHandler}
                    onToggleListMapViewState={StoreSelectorActions.toggleListMapViewState}
                    displayList={displayList}
                    locatorView={showLocationView}
                    productPickUpDeliveryOptions={storeSelectorStateManager?.context?.deliveryOptions?.DeliveryOptions}
                    telemetryContent={this.telemetryContent}
                    filterPickupModeSelected={this.onFilteredPickupMode}
                    hasEnabledPickupFilterToShowStore={enablePickupFilterToShowStore}
                    filteredPickupMode={this.state.filteredPickupMode}
                    sortLocations={this.sortLocations}
                    sortByLocation={this.state.sortByLocation}
                    allStore={this.state.allStore.length}
                    loading={this.state.isSearchInProgress}
                    isDialogOpen={storeSelectorStateManager?.isDialogOpen}
                    onSuggestionsSelected={this._onSuggestionSelected}
                    useAzureMaps={channel?.AzureMapsEnabled ?? false}
                    autoSuggestionEnabled={isAutoSuggestionsEnabled}
                    autoSuggestOptions={autoSuggestOptions}
                    telemetry={telemetry}
                    channel={channel}
                    locale={locale}
                    isMapAPILoaded={storeSelectorStateManager?.isMapApiLoaded}
                />
            ),
            spinner: <StoreSelectorWaiting />,
            locationsList: ((availabilitiesWithHours && availabilitiesWithHours.length) || (storeLocations && storeLocations.length)) && (
                <StoreSelectorLocationLines
                    locations={storesList}
                    resources={resources}
                    preferredDistanceUnit={preferredDistanceUnit}
                    alreadySelectedLocation={context ? context.alreadySelectedLocation : undefined}
                    outOfStockThreshold={appConfig.outOfStockThreshold || 0}
                    enableOutOfStockCheck={appConfig.enableStockCheck || false}
                    onLocationSelected={this._onOrgUnitLocationSelected}
                    storeLocatorView={locatorView}
                    selectedStoreLocationId={selectedStoreLocationId}
                    onClick={this._setSelectedStore}
                    preferredStoreLocationId={preferredStore?.StoreId ? preferredStore.StoreId : ''}
                    onSetAsPreferredStore={this._setPreferredStore}
                    onRemovePreferredStore={this._removePreferredStore}
                    isPreferredStoreEnabled={isPreferredStoreEnabled}
                    displayList={displayList}
                    telemetryContent={this.telemetryContent}
                    isLocationDisabled={this.state.isLocationDisabled}
                    productPickUpDeliveryOptions={storeSelectorStateManager?.context?.deliveryOptions?.DeliveryOptions}
                    showQuantity={showLiveQuantity}
                    filteredPickupMode={this.state.filteredPickupMode}
                    isDisplayProduct={this.state.isDisplayProduct}
                    sortByLocation={this.state.sortByLocation}
                    showCnC={this.state.isCnC && !this.state.isDisplayProduct}
                    pickupStoreIds={this.state.CnCPickupIds}
                    storeHeadingForLocalStore={this.props.config.storeSelectorHeaderText!}
                    config={this.props.config}
                    apiSettings={this.props.context.request.apiSettings}
                    gridSettings={this.props.context.request.gridSettings}
                    context={this.props.context}
                    product={storeSelectorStateManager?.context?.product as SimpleProduct | undefined}
                />
            ),
            noLocationsMessage: <StoreSelectorEmptyMessage resources={resources} />,
            terms: (
                <StoreSelectorTermsOfService
                    link={termsOfServiceLink}
                    onTextChange={this.handleLinkTextChange}
                    requestContext={this.props.context.request}
                />
            ),

            // Not being used in current context, we can use it here to pass more props.
            headerText: <span>{heading ? heading : locatorView ? storeSelectorHeaderText : storeSelectorHeaderText}</span>,
            sortLocations: storeLocationList,
            isDisplayProduct: this.state.isDisplayProduct,
            locationListProps,
            callbacks: {
                searchTermChanged: this._searchTermChanged,
                performSearch: this._performSearch,
                closeDialog: this._closeDialog,
                selectedLocation: this._onOrgUnitLocationSelected,
                getAndUpdateUserLocation: async () => {
                    this._getAndUpdateStoreLocation();
                    return Promise.resolve();
                },
                onSuggestionSelected: this._onOrgUnitLocationSelected,
                setPreferredStore: this._setPreferredStore,
                removePreferredStore: this._removePreferredStore,
                setSelectedStore: this._setSelectedStore,
                setOrgUnitStoreInformation: this._setOrgUnitStoreInformation
            }
        } as IStoreSelectorViewProps;

        return this.props.renderView(viewProps) as React.ReactElement;
    }

    public handleLinkTextChange = (event: Msdyn365.ContentEditableEvent) => {
        if (this.props.config.termsOfServiceLink) {
            this.props.config.termsOfServiceLink.linkText = event.target.value;
        }
    };

    public handleHeadingChange = (event: Msdyn365.ContentEditableEvent) => (this.props.config.heading = event.target.value);

    /**
     * Show all stores handler function.
     */

    private readonly onShowAllStoresHandler = () => {
        this._getAndUpdateStoreLocation(true);
        this.setState({ filteredPickupMode: undefined, isSearchCompleted: false });
    };
    /**
     * Method to be called for filtered the store location based on the filter selected by the user.
     * @param stores -All the stores from the API.
     * @param filteredPickupMode -Filter selected by the user.
     * @returns -Filtered stores.
     */

    private readonly onFilterLocations = (stores: IFullOrgUnitAvailability[], filteredPickupMode: string) => {
        return stores.filter(location => {
            return location.OrgUnitPickUpDeliveryModes?.DeliveryOptions?.some(deliveryOption => {
                return deliveryOption.Code === filteredPickupMode;
            });
        });
    };
    /**
     * Filter Store by pickup mode.
     * @param deliveryCode -Delivery Code.
     */

    private readonly onFilteredPickupMode = (deliveryCode: string) => {
        this.setState({ filteredPickupMode: deliveryCode });
    };
    /**
     * Method will sort all stores.
     * @param stores -Stores List.
     * @param isPreferredStoreEnabled -Module config value.
     * @param preferredStoreLocationId -Store Id.
     * @returns List of Stores.
     */

    // eslint-disable-next-line class-methods-use-this -- No need of introducing new variable.
    private _sortStores(
        stores: IFullOrgUnitAvailability[],
        isPreferredStoreEnabled: boolean | undefined,
        preferredStoreLocationId: string
    ): IFullOrgUnitAvailability[] {
        const isPreferredStore = (value: IFullOrgUnitAvailability) =>
            isPreferredStoreEnabled &&
            preferredStoreLocationId &&
            value.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitNumber === preferredStoreLocationId;
        return [...stores.filter(isPreferredStore), ...stores.filter(store => !isPreferredStore(store))];
    }
    /**
     * Method will list of store selector location line.
     * @param hasEnabledOutOfStockCheck -Stores List.
     * @param isStoreLocatorView -Module config value.
     * @param preferredStoreLocationId -Store Id.
     * @param isPreferredStoreEnabled -Stores List.
     * @param selectedStoreLocationId -Module config value.
     * @param stores -Store Id.
     * @param preferredDistanceUnit -Module config value.
     * @param alreadySelectedLocation -Already Selected Location.
     * @param productPickUpOptionList -Product supported Pickup Modes List.
     * @returns List of StoreSelectorLocation Line.
     */

    private _getStoreLocationListProps(
        hasEnabledOutOfStockCheck: boolean,
        isStoreLocatorView: boolean,
        preferredStoreLocationId: string,
        isPreferredStoreEnabled: boolean | undefined,
        selectedStoreLocationId: string | undefined,
        stores: IFullOrgUnitAvailability[] | null,
        preferredDistanceUnit?: string | undefined,
        alreadySelectedLocation?: OrgUnitLocation,
        productPickUpOptionList?: DeliveryOption[]
    ): IStoreSelectorLocationLineItemProps[] {
        const storeList: IStoreSelectorLocationLineItemProps[] = [];
        if (ArrayExtensions.hasElements(stores)) {
            stores?.map((store, index: number) => {
                const storeLineProps = this._createStoreLocationList(
                    store,
                    index,
                    hasEnabledOutOfStockCheck,
                    isStoreLocatorView,
                    preferredStoreLocationId,
                    isPreferredStoreEnabled,
                    selectedStoreLocationId,
                    preferredDistanceUnit,
                    alreadySelectedLocation,
                    productPickUpOptionList
                );
                if (storeLineProps) {
                    storeList.push(storeLineProps);
                }
            });
        }
        return storeList;
    }

    private readonly _onSuggestionSelected = async (result: ISuggestion): Promise<void> => {
        const context =
            this.props.data.storeSelectorStateManager &&
            this.props.data.storeSelectorStateManager.result &&
            this.props.data.storeSelectorStateManager.result?.context;
        if (context && context?.id === this.props.id) {
            await this._searchTermChanged(result.formattedSuggestion);
            await this._performSearch(result.formattedSuggestion, result.latitude, result.longitude);
        }
    };

    private readonly _setPreferredStore = async (storeId: string | undefined): Promise<void> => {
        if (!storeId) {
            return;
        }

        const {
            context: {
                actionContext: {
                    requestContext: { cookies }
                }
            },
            config: { mode },
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager },
                storeLocations: { result: storeLocations },
                availabilitiesWithHours: { result: availabilitiesWithHours }
            }
        } = this.props;

        if (!storeSelectorStateManager) {
            return;
        }
        const modeDefault = mode !== undefined ? mode : modeEnum.pickupInStore;

        let stores: IFullOrgUnitAvailability[];
        if (modeDefault === modeEnum.findStores && storeLocations) {
            stores = storeLocations;
        } else {
            stores = availabilitiesWithHours!;
        }

        const preferedStore = stores.find(store => store.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitNumber === storeId);

        await storeSelectorStateManager.setPreferredStoreLocation(
            storeId,
            preferedStore?.OrgUnitAvailability?.OrgUnitLocation?.OrgUnitName,
            cookies?.isConsentGiven(),
            preferedStore?.OrgUnitAvailability?.OrgUnitLocation?.Latitude,
            preferedStore?.OrgUnitAvailability?.OrgUnitLocation?.Longitude
        );
    };

    private readonly _removePreferredStore = async (): Promise<void> => {
        const {
            context: {
                actionContext: {
                    requestContext: { cookies }
                }
            },
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        if (!storeSelectorStateManager) {
            return;
        }

        await storeSelectorStateManager.clearPreferredStore(cookies?.isConsentGiven());
    };

    private readonly _setSelectedStore = async (storeId: string | undefined): Promise<void> => {
        const {
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        if (!storeSelectorStateManager) {
            return;
        }

        await storeSelectorStateManager.setSelectedStoreLocationId(storeId);
    };

    private readonly _performSearch = async (searchTerm: string, latitude?: number, longitude?: number): Promise<void> => {
        const {
            context: { actionContext },
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager },
                customStoreSelectorStateManager: { result: customStoreSelectorStateManager }
            }
        } = this.props;

        if (!searchTerm || !storeSelectorStateManager || !customStoreSelectorStateManager) {
            return;
        }

        this.setState({ isSearchInProgress: true, isSeeAllStoreValue: false });

        const location =
            latitude && longitude
                ? { latitude, longitude }
                : await storeSelectorStateManager.geoLocate(searchTerm.trim() || '0', actionContext);

        await this._updateLocations(location?.latitude, location?.longitude);

        this.setState({ isSearchInProgress: false, isSearchCompleted: true });
    };

    private readonly _searchTermChanged = async (searchTerm: string): Promise<void> => {
        this.setState({ searchTerm });
    };

    private readonly _getAndUpdateStoreLocation = (showAllStores?: boolean): void => {
        const {
            config: { style },
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        const styleDefault = style !== undefined ? style : styleEnum.dialog;

        if (styleDefault !== styleEnum.inline && (!storeSelectorStateManager || !storeSelectorStateManager.isDialogOpen)) {
            // Store selector dialog isn't open yet, so don't try and update anything
            return;
        }

        this.setState({ isSearchInProgress: true, isSeeAllStoreValue: false });

        /* VSI-Customization -- Call dataAction to get All stores info  */
        this.getAllAvailableStoreInventoryNearby(0, 0, this.state.latitudeVal, this.state.longitudeVal).then(async () => {
            if (navigator && navigator.geolocation) {
                const { locationData } = this.state;
                if (locationData) {
                    this.setState({
                        isLocationDisabled: false,
                        isSearchInProgress: true,
                        sortByLocation: true,
                        latitudeVal: locationData.latitude,
                        longitudeVal: locationData.longitude
                    });
                    if (showAllStores) {
                        this.setState({ isSeeAllStoreValue: true, isSearchInProgress: true });
                        await this._searchTermChanged('');
                        await this._updateLocations(locationData.latitude, locationData.longitude, 0);
                    } else {
                        // await this._updateLocations(51.3679435344, 0.0384523487);
                        await this._updateLocations(locationData.latitude, locationData.longitude);
                    }
                } else {
                    // locationData is null and user location is disabled
                    this.setState({ isLocationDisabled: true, sortByLocation: undefined });
                    if (showAllStores) {
                        this.setState({ isSeeAllStoreValue: true, isSearchInProgress: true });
                        await this._searchTermChanged('');
                        await this._updateLocations(void 0, void 0, 0);
                    } else {
                        await this._updateLocations();
                    }
                }
                this.setState({ isSearchInProgress: false });
            } else {
                this.setState({ isSearchInProgress: false });
            }
        });
    };

    private readonly _closeDialog = async (): Promise<void> => {
        this.props.context.actionContext.update(new PdpClickCollectModalStateInput(), { isModalOpen: false });
        const {
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        this.setState({ searchTerm: '' });

        if (storeSelectorStateManager) {
            storeSelectorStateManager.context?.parentElementRef?.current?.focus();
            document.body.classList.remove('store-locator-open');
            return storeSelectorStateManager.closeDialog();
        }
    };

    private readonly _setOrgUnitStoreInformation = async (orgUnitStoreInformation: IFullOrgUnitAvailability[]): Promise<void> => {
        const {
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            },
            config: { style },
            telemetry
        } = this.props;

        if (!storeSelectorStateManager) {
            return;
        }

        const context = storeSelectorStateManager.context;

        const id: string = context && context.id ? context.id : this.props.id;
        const styleDefault = style !== undefined ? style : styleEnum.dialog;
        await storeSelectorStateManager
            .setOrgUnitStoreInformation({
                id,
                showMapViewLink: context && context.showMapViewLink,
                parentElementRef: context?.parentElementRef,
                isDialog: styleDefault === styleEnum.dialog,
                orgUnitStoreInformation,
                onLocationSelected: async orgUnitLocation => {
                    // TO-DO handle event for when location in selected
                    return Promise.resolve();
                }
            })
            .catch((error: Error) => {
                if (telemetry) {
                    telemetry.error(error.message);
                    telemetry.debug('Unable to Update store location state');
                }
                return;
            });
        return;
    };

    /**
     * Get full available inventory nearby.
     * @param calRadius - Radius.
     * @param distanceUnitValue - Distance unit value.
     * @param latitude - Latitude.
     * @param longitude - Longitude.
     * @returns - Returns a void promise.
     */
    private readonly getAllAvailableStoreInventoryNearby = async (
        calRadius: number,
        distanceUnitValue: number,
        latitude?: number,
        longitude?: number
    ): Promise<void> => {
        const {
            telemetry,
            context: { actionContext },
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        if (!storeSelectorStateManager || !storeSelectorStateManager.context) {
            // Store selector dialog isn't open yet, so don't try and update anything
            return;
        }

        if (!storeSelectorStateManager.context.product) {
            // TODO: Use alternative search method here to not make inventory check
            return;
        }
        this.setState({ isSearchInProgress: true });

        const pickupStores = await searchOrgUnitLocationsAsync(
            { callerContext: this.props.context.actionContext, bypassCache: 'none' },
            {
                DeliveryModeTypeFilterValue: 2
            }
        );

        const shippingStores = await searchOrgUnitLocationsAsync(
            { callerContext: this.props.context.actionContext, bypassCache: 'none' },
            {
                DeliveryModeTypeFilterValue: 1
            }
        );

        const pickupIds = pickupStores.map(store => store.ChannelId);
        // this.setState({ CnCPickupIds: pickupIds });
        const shippingIds = shippingStores.map(store => store.ChannelId);
        const excludedIds = shippingIds.filter(id => !pickupIds.includes(id));

        const input = new GetAllAvailableInventoryNearbyInput(
            storeSelectorStateManager.context.product.RecordId,
            latitude ?? 0,
            longitude ?? 0,
            calRadius,
            distanceUnitValue,
            this.state.isLocationDisabled,
            excludedIds
        );

        const allStoresNearBy = await getAllAvailableInventoryNearbyAction(input, actionContext).catch(error => {
            telemetry.warning(error);
            telemetry.error(error.message);
            telemetry.debug('Unable to get full available inventory near by');
            // this.trackException('DobbiesBuyBoxStoreSelector: Get Full Available Inventory Nearby', error.message, error.stack);
        });
        if (allStoresNearBy && allStoresNearBy?.length >= 1) {
            this.setState({ allStore: allStoresNearBy });
        }
        //this.setState({ isSearchInProgress: false });
    };

    private readonly _updateLocations = async (latitude?: number, longitude?: number, radius?: number): Promise<void> => {
        const {
            telemetry,
            config: { mode, lookupRadius, style },
            context: { actionContext },
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        const styleDefault = style !== undefined ? style : styleEnum.dialog;
        const calRadius = radius || radius === 0 ? radius : lookupRadius || 50;
        const distanceUnitValue = this.props.config.searchRadiusUnit === SearchRadiusUnit.kilometers ? 1 : 0;
        const modeDefault = mode !== undefined ? mode : modeEnum.pickupInStore;
        const preferredStore: IStoreInfo | undefined = storeSelectorStateManager?.preferredStore;
        let lat = this.state.searchTerm || !preferredStore?.Latitude ? latitude : preferredStore.Latitude;
        let long = this.state.searchTerm || !preferredStore?.Longitude ? longitude : preferredStore.Longitude;
        if (styleDefault === styleEnum.inline) {
            const lastInlineStoreLocation = storeSelectorStateManager?.lastInlineShownStoreInfo;
            if (lastInlineStoreLocation && !this.state.searchTerm) {
                lat = lastInlineStoreLocation.Latitude ? lastInlineStoreLocation.Latitude : lat;
                long = lastInlineStoreLocation.Longitude ? lastInlineStoreLocation.Longitude : long;
            }
            await storeSelectorStateManager?.setLastInlineStoreInfo(lat, long);
        }

        if (modeDefault === modeEnum.findStores) {
            const orgUnitLocationsInput = new GetOrgUnitLocationsByAreaInput(
                lat,
                long,
                calRadius,
                distanceUnitValue,
                this.state.isLocationDisabled
            );

            const orgUnitLocations = await getOrgUnitLocationsByArea(orgUnitLocationsInput, actionContext);
            if (orgUnitLocations) {
                await this._setOrgUnitStoreInformation(orgUnitLocations);
                await this._setSelectedStore(undefined);
            }
            return;
        }

        if (!storeSelectorStateManager || !storeSelectorStateManager.context) {
            // Store selector dialog isn't open yet, so don't try and update anything
            return;
        }

        if (!storeSelectorStateManager.context.product) {
            // TODO: Use alternative search method here to not make inventory check
            return;
        }

        const pickupStores = await searchOrgUnitLocationsAsync(
            { callerContext: this.props.context.actionContext, bypassCache: 'none' },
            {
                DeliveryModeTypeFilterValue: 2
            }
        );

        const shippingStores = await searchOrgUnitLocationsAsync(
            { callerContext: this.props.context.actionContext, bypassCache: 'none' },
            {
                DeliveryModeTypeFilterValue: 1
            }
        );

        const pickupIds = pickupStores.map(store => store.ChannelId);
        this.setState({ CnCPickupIds: pickupIds });
        const shippingIds = shippingStores.map(store => store.ChannelId);
        const excludedIds = shippingIds.filter(id => !pickupIds.includes(id));

        const input = new GetFullAvailableInventoryNearbyInput(
            storeSelectorStateManager.context.product.RecordId,
            lat || 0,
            long || 0,
            calRadius,
            distanceUnitValue,
            this.state.isLocationDisabled,
            excludedIds
        );

        await getFullAvailableInventoryNearby(input, actionContext).catch(error => {
            telemetry.warning(error);
            telemetry.error(error.message);
            telemetry.debug('Unable to get full available inventory near by');
        });
    };

    private readonly _onOrgUnitLocationSelected = async (location: OrgUnitLocation | undefined, deliveryMode?: string): Promise<void> => {
        const {
            telemetry,
            data: {
                storeSelectorStateManager: { result: storeSelectorStateManager }
            }
        } = this.props;

        if (storeSelectorStateManager) {
            if (location && storeSelectorStateManager.context) {
                // Want to eat exceptions here so that the dialog still closes even if the onLocationSelected call goes wrong
                await storeSelectorStateManager.context.onLocationSelected(location, deliveryMode).catch(error => {
                    telemetry.warning(error);
                    telemetry.error(error.message);
                    telemetry.debug('Unable to get on org unit location selected');
                });
            }

            await storeSelectorStateManager.closeDialog();
        }
    };
    /**
     * Method will list of store selector location line.
     * @param store -Store Info.
     * @param index - List index.
     * @param hasEnabledOutOfStockCheck -Stores List.
     * @param isStoreLocatorView -Module config value.
     * @param preferredStoreLocationId -Store Id.
     * @param isPreferredStoreEnabled -Stores List.
     * @param selectedStoreLocationId -Module config value.
     * @param preferredDistanceUnit -Module config value.
     * @param alreadySelectedLocation -Already Selected Location.
     * @param productPickUpOptionList -Product supported Pickup Modes List.
     * @returns StoreSelectorLocation Line Prop.
     */

    private _createStoreLocationList(
        store: IFullOrgUnitAvailability,
        index: number,
        hasEnabledOutOfStockCheck: boolean,
        isStoreLocatorView: boolean,
        preferredStoreLocationId: string,
        isPreferredStoreEnabled: boolean | undefined,
        selectedStoreLocationId: string | undefined,
        preferredDistanceUnit?: string | undefined,
        alreadySelectedLocation?: OrgUnitLocation,
        productPickUpOptionList?: DeliveryOption[]
    ): IStoreSelectorLocationLineItemProps | undefined {
        const orgUnitLocation = store?.OrgUnitAvailability?.OrgUnitLocation;
        const selectedStoreLocation = selectedStoreLocationId;
        const deliveryOptions = store?.OrgUnitPickUpDeliveryModes;
        const lineResources = this._mapResources(this.props.resources);
        const storeOpenFrom: string | undefined = secondsToTime(orgUnitLocation?.OpenFrom);
        const storeOpenTo: string | undefined = secondsToTime(orgUnitLocation?.OpenTo);
        const storeHours = store.StoreHours;
        if (orgUnitLocation) {
            ++this.storeCounter;
            return {
                location: orgUnitLocation,
                selectedStoreLocationId: selectedStoreLocation,
                storeHours,
                resources: lineResources,
                preferredDistanceUnit: preferredDistanceUnit!,
                isCurrentLocation: this._isCurrentLocation(orgUnitLocation, alreadySelectedLocation),
                isInStock: this._isProductInStock(hasEnabledOutOfStockCheck, store?.OrgUnitAvailability?.ItemAvailabilities),
                stockStatusLabel: this._stockInventoryLabel(store),
                storeLocatorView: isStoreLocatorView,
                index: this.storeCounter.toString(),
                preferredStoreLocationId,
                isPreferredStoreEnabled,
                telemetryContent: this.telemetryContent,
                isLocationDisabled: this.state.isLocationDisabled,
                storePickUpOptionList: deliveryOptions?.DeliveryOptions,
                productPickUpOptionList,
                locationOpen: { openFrom: storeOpenFrom, openTo: storeOpenTo },
                storeHoursList: storeHours?.RegularStoreHours ? buildStoreHours(storeHours.RegularStoreHours, lineResources) : [],
                onClick: this._setSelectedStore,
                handlers: {
                    onSelected: this._onOrgUnitLocationSelected,
                    onSetAsPreferredStore: this._setPreferredStore,
                    onRemovePreferredStore: this._removePreferredStore
                }
            };
        }
        return undefined;
    }
    /**
     * Method to map resources with Location Item.
     * @param resources - List of strings for module.
     * @returns Resources for StoreSelector location line.
     */

    private readonly _mapResources = (resources: IDobbiesBuyboxStoreSelectorResources): IStoreSelectorLocationLineItemResources => {
        return {
            contactInfoHeader: resources.contactText,
            storeHoursHeader: resources.timeText,
            availabilityInfoHeader: resources.availabilityText,
            closedText: resources.storeHoursClosedText,
            outOfStock: resources.outOfStockText,
            inStock: resources.inStockText,
            currentLocation: resources.selectedStoreLocationText,
            selectLocation: resources.selectStoreText,
            selectLocationAriaLabelFormat: resources.selectStoreAriaFormatText,
            setAsPreferredStoreText: resources.setAsPreferredStoreText,
            setAsPreferredStoreTextAriaLabel: resources.setAsPreferredStoreTextAriaLabel,
            preferredStoreText: resources.preferredStoreText,
            preferredStoreAriaLabel: resources.preferredStoreAriaLabel,
            quantityText: resources.quantityText,
            days: {
                monday: resources.storeHoursMondayText,
                tuesday: resources.storeHoursTuesdayText,
                wednesday: resources.storeHoursWednesdayText,
                thursday: resources.storeHoursThursdayText,
                friday: resources.storeHoursFridayText,
                saturday: resources.storeHoursSaturdayText,
                sunday: resources.storeHoursSundayText,
                mondayFull: resources.storeHoursMondayFullText,
                tuesdayFull: resources.storeHoursTuesdayFullText,
                wednesdayFull: resources.storeHoursWednesdayFullText,
                thursdayFull: resources.storeHoursThursdayFullText,
                fridayFull: resources.storeHoursFridayFullText,
                saturdayFull: resources.storeHoursSaturdayFullText,
                sundayFull: resources.storeHoursSundayFullText
            }
        };
    };
    private readonly _isCurrentLocation = (location: OrgUnitLocation | undefined, selectedLocation?: OrgUnitLocation): boolean =>
        (selectedLocation && location && selectedLocation.OrgUnitNumber === location.OrgUnitNumber) || false;
    /**
     * Method to get stock.
     * @param hasEnableOutOfStockCheck - Config to check for stock check enabled.
     * @param itemAvailabilities - Item quantity availablity.
     * @returns Boolean value for item stock.
     */

    private readonly _isProductInStock = (
        hasEnableOutOfStockCheck: boolean,
        itemAvailabilities: ItemAvailability[] | undefined
    ): boolean => {
        if (!hasEnableOutOfStockCheck) {
            return true;
        }
        const quantityCount = 0;
        if (ArrayExtensions.hasElements(itemAvailabilities)) {
            return itemAvailabilities[0].AvailableQuantity ? itemAvailabilities[0].AvailableQuantity > quantityCount : false;
        }
        return false;
    };
    /**
     * Method to get stocklevel label.
     * @param isInStock - Stock available in store.
     * @returns Label for stock status.
     */

    private readonly _stockInventoryLabel = (isInStock: IFullOrgUnitAvailability | undefined): string | undefined => {
        if (isInStock?.ProductInventoryInformation && ArrayExtensions.hasElements(isInStock.ProductInventoryInformation)) {
            for (let index = 0; index < isInStock.ProductInventoryInformation.length; index++) {
                if (
                    isInStock.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId ===
                    isInStock.ProductInventoryInformation[index].InventLocationId
                ) {
                    return isInStock.ProductInventoryInformation[index].StockLevelLabel;
                }
            }
        }
        return undefined;
    };
}

export default StoreSelector;
